var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66497 8L9.48766 10.8227C9.75699 11.092 9.75699 11.5287 9.48766 11.798C9.21833 12.0673 8.78167 12.0673 8.51234 11.798L5.202 8.48766C4.93267 8.21833 4.93267 7.78167 5.202 7.51234L8.51234 4.202C8.78167 3.93267 9.21833 3.93267 9.48766 4.202C9.75699 4.47132 9.75699 4.90799 9.48766 5.17732L6.66497 8Z",
    fill: "#3F3356"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.4e1f77fe02763ba70c44e5cd74695b9f.svg";
export { ForwardRef as ReactComponent };